module.exports = __webpack_public_path__ + "static/img/issue_agreement.93484ccc.png";